module.exports = __webpack_public_path__ + "static/media/KgTeacherHelpers-q4J1.865baafe.ttf";